import { render, staticRenderFns } from "./SchemaCreate.vue?vue&type=template&id=88819688&"
import script from "./SchemaCreate.vue?vue&type=script&lang=ts&"
export * from "./SchemaCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports